/** Serializes full-adapter-record writes so each mutation starts from the last successful response. */
export const createAdapterSaveQueue = <T>() => {
  let latest: T | undefined;
  let pending = 0;
  let tail = Promise.resolve();
  return {
    sync(value: T | undefined, isFresh: (current: T, incoming: T) => boolean = () => true) {
      if (pending === 0 && (!latest || !value || isFresh(latest, value))) latest = value;
    },
    current() {
      return latest;
    },
    wait() {
      return tail;
    },
    save(write: (current: T) => Promise<T>, preferred?: T): Promise<T> {
      pending += 1;
      const result = tail.then(async () => {
        const current = preferred ?? latest;
        if (!current) throw new Error("Release is unavailable.");
        const next = await write(current);
        latest = next;
        return next;
      });
      tail = result.then(
        () => { pending -= 1; },
        () => { pending -= 1; },
      );
      return result;
    },
  };
};

export type AdapterSaveQueue<T> = ReturnType<typeof createAdapterSaveQueue<T>>;
